const lg = '(max-width: 1199px)';
const mid = '(max-width: 820px)';
const tabletHor = '(max-width: 1023px)';
const tablet = '(max-width: 768px)';
const phone = '(max-width: 767px)';
const sm = '(min-width: 600px)';

const isViewport = mq => {
	return window.matchMedia(mq).matches;
};

export default isViewport;
export {lg, tablet, tabletHor, mid, sm, phone};



/** WEBPACK FOOTER **
 ** ./app/scripts/util/window/isViewport.js
 **/